let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("59WAv")).then(() => parcelRequire('cwu9F'));